<template>
  <div class="full-panel">
    <div class="top-block">
      <slot name="top" />
    </div>
    <div class="middle-block">
      <ScrollShadow>
        <slot name="center" />
      </ScrollShadow>
    </div>
    <div class="bottom-block">
      <slot name="bottom" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { ScrollShadow } from '@warrenbrasil/nebraska-web';

@Component({
  components: { ScrollShadow }
})
export default class FullHeightPanel extends Vue {}
</script>

<style lang="less" scoped>
.full-panel {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
}

.top-block,
.bottom-block {
  flex: 1 0;
}

.middle-block {
  flex: 1 1 100%;
  overflow: auto;
}

.columns-grid {
  display: grid;

  @media @tabletDown {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
</style>
